import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './components/Header';
import Sidebar from './components/Sidebar';
import Footer from './components/Footer';
import Home from './pages/Home';
import BookForm from './pages/BookForm';
import ChapterForm from './pages/ChapterForm';
import JournalForm from './pages/JournalForm';
import MagazineForm from './pages/MagazineForm';
import NewspaperForm from './pages/NewspaperForm';
import BlogForm from './pages/BlogForm';
import EventForm from './pages/EventForm';
import ThesisForm from './pages/ThesisForm';
import MovieForm from './pages/MovieForm';
import PodcastForm from './pages/PodcastForm';
import SocialMediaForm from './pages/SocialMediaForm';
import LlmForm from './pages/LlmForm';
import WebsiteForm from './pages/WebsiteForm';
import WikipediaForm from './pages/WikipediaForm';
import VisualMaterialForm from './pages/VisualMaterialForm';
import './App.css';

function App() {
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);

  // Prevenir el scroll del body cuando el sidebar está abierto en móvil
  useEffect(() => {
    if (isSidebarOpen && window.innerWidth < 768) {
      document.body.classList.add('sidebar-open');
    } else {
      document.body.classList.remove('sidebar-open');
    }

    // Cleanup al desmontar el componente
    return () => {
      document.body.classList.remove('sidebar-open');
    };
  }, [isSidebarOpen]);

  // Variants for page transitions
  const pageVariants = {
    initial: { opacity: 0, y: 20 },
    in: { opacity: 1, y: 0 },
    out: { opacity: 0, y: -20 }
  };

  const pageTransitionSettings = {
    type: 'tween',
    ease: 'anticipate',
    duration: 0.3
  };

  // A wrapper component for page transitions
  const PageTransition = ({ children }) => {
    return (
      <motion.div
        initial="initial"
        animate="in"
        exit="out"
        variants={pageVariants}
        transition={pageTransitionSettings}
      >
        {children}
      </motion.div>
    );
  };

  return (
    <Router>
      <div className="min-h-screen bg-gray-50 dark:bg-gray-900 transition-colors duration-300">
        <Header onMenuClick={() => setIsSidebarOpen(!isSidebarOpen)} />
        <div className="flex">
          {/* Sidebar para todas las pantallas - controlado por el estado isSidebarOpen */}
          <Sidebar
            isOpen={isSidebarOpen}
            onClose={() => setIsSidebarOpen(false)}
          />

          <main className={`flex-1 transition-all duration-300 ${
            isSidebarOpen ? 'md:ml-64' : 'ml-0'
          }`}>
            <div className="container mx-auto px-4 py-8">
              <AnimatePresence mode="wait">
                <Routes>
                  <Route path="/" element={<PageTransition><Home /></PageTransition>} />
                  <Route path="/libro" element={<PageTransition><BookForm /></PageTransition>} />
                  <Route path="/capitulo" element={<PageTransition><ChapterForm /></PageTransition>} />
                  <Route path="/revista" element={<PageTransition><JournalForm /></PageTransition>} />
                  <Route path="/magazin" element={<PageTransition><MagazineForm /></PageTransition>} />
                  <Route path="/periodico" element={<PageTransition><NewspaperForm /></PageTransition>} />
                  <Route path="/blog" element={<PageTransition><BlogForm /></PageTransition>} />
                  <Route path="/evento" element={<PageTransition><EventForm /></PageTransition>} />
                  <Route path="/tesis" element={<PageTransition><ThesisForm /></PageTransition>} />
                  <Route path="/pelicula" element={<PageTransition><MovieForm /></PageTransition>} />
                  <Route path="/podcast" element={<PageTransition><PodcastForm /></PageTransition>} />
                  <Route path="/redes-sociales" element={<PageTransition><SocialMediaForm /></PageTransition>} />
                  <Route path="/llm" element={<PageTransition><LlmForm /></PageTransition>} />
                  <Route path="/sitio-web" element={<PageTransition><WebsiteForm /></PageTransition>} />
                  <Route path="/wikipedia" element={<PageTransition><WikipediaForm /></PageTransition>} />
                  <Route path="/material-visual" element={<PageTransition><VisualMaterialForm /></PageTransition>} />
                </Routes>
              </AnimatePresence>
              <Footer />
            </div>
          </main>
        </div>
      </div>
    </Router>
  );
}

export default App;